import svg4everybody from 'svg4everybody';
import { html } from './utils/environment';

export default function() {
    svg4everybody();

    // ==========================================================================
    // isMobile
    // ==========================================================================
    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    window.isMobile = isMobile;

    if(window.isMobile) {
        html.classList.add('is-mobile');
    }

    // ==========================================================================
    // isDebug
    // ==========================================================================
    const isDebug = (html.dataset.debug == 'true') ? true : false;
    window.isDebug = isDebug;

    if(window.isDebug) {
        html.classList.add('is-debug');
    }

    // ==========================================================================
    // vh
    // ==========================================================================

    let viewportWidth = window.innerWidth
    // console.log(window.innerHeight);
    html.style.setProperty(
        '--vh',
        `${window.innerHeight * 0.01}px`
    )

    window.addEventListener('resize', () => {

        // if(window.innerWidth > 1024 && window.matchMedia("(hover: hover)"))

        if(window.innerWidth != viewportWidth && (window.matchMedia("(hover: none)" || window.innerWidth < 1024))) {
            viewportWidth = window.innerWidth
            html.style.setProperty(
                '--vh',
                `${window.innerHeight * 0.01}px`
            )
        }
    })
}
